import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {getUserPurchases, createOfferCheckout, finalizeOfferPayment} from './offer-api';
import {Platform} from 'react-native';
import {useOrganizationOffers as useOrganizationOffersFromAppData} from './app-data-hooks';
import {AppDataOffer} from './app-data-interfaces';
import {appDataKeys} from './app-data-keys';

// Export the hook from app-data-hooks for consistency
export {useOrganizationOffers} from './app-data-hooks';

export function useUserPurchases() {
    return useQuery({
        queryKey: ['userPurchases'],
        queryFn: getUserPurchases,
    });
}

export function useCreateOfferCheckout() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({offerId, paymentProvider}: {offerId: string; paymentProvider?: string}) =>
            createOfferCheckout(offerId, paymentProvider),
        onSuccess: () => {
            // Invalidate purchases after successful checkout
            queryClient.invalidateQueries({queryKey: ['userPurchases']});
        },
    });
}

export function useCanPurchase() {
    // Purchases are only allowed on web platform
    return Platform.OS === 'web';
}

export function useFinalizeOfferPayment() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (params: {
            offerId: string;
            purchaseId: string;
            token?: string;
            sessionId?: string;
        }) => finalizeOfferPayment(params.offerId, params.purchaseId, params.token, params.sessionId),
        onSuccess: (data) => {
            // Invalidate app data to refresh purchase status
            queryClient.invalidateQueries({queryKey: appDataKeys.detail()});
            // Also invalidate user purchases
            queryClient.invalidateQueries({queryKey: ['userPurchases']});
        },
    });
}